
import { mapState } from 'vuex'

export default {
  scrollToTop: true,

  head() {
    return {
      title: this.$t('standard-access'),
    }
  },

  computed: {
    ...mapState('global', ['registrationSettings']),
  },

  methods: {
    onRegistered() {
      this.$toast.clear()
      this.$toast.success(this.$t('registration-standard-successful'), {
        duration: 6000,
      })
    },
  },
}
